module.exports = __webpack_public_path__ + "static/scale-model-of-school-of-travel-and-tourism-in-lewisville-texas-70cf24ed8dfa7db20c903e344e484257.png";